import superagent from "superagent";
import InvalidResponse from "../error/InvalidResponse";
import InvalidRequest from "../error/InvalidRequest";
import AuthorisationError from "../error/AuthorisationError";
import ServerError from "../error/ServerError";

import eventBus from 'module/eventBus';

let store = null;

eventBus.$on('store', (globalStore) => {
  store = globalStore;
});

const RECAPTCHA_SITE_KEY = '6LeuZIUUAAAAALltDnzTlxhRfwD3Mc1a0AQdbKkS';

export default class ApiRequest {
  constructor(route, type) {
    this._type = type;
    this.request = null;
    this._route = null;


    this.recaptchaAction = null;
    this.sendData = {};
    this.originalThen = null;
  }

  type(type) {
    this._type = type;
    return this;
  }

  route(route) {
    this._route = route;
    return this;
  }

  init() {
    let routeFromEnvironment = _.get(store, 'state.environment.environment.route', DEFAULT_ENVIRONMENT);

    this.request = superagent(this._type, 'api.php?a=' + _.compact([routeFromEnvironment, this._route]).join('/'));
    this.request.idToken = this._idToken();
    this.request.recaptchaAction = this._recaptchaAction();
    this.request.data = this._data();

    this.originalThen = this.request.then;

    this.request.then = this._thenOverride();

    return this.request;
  }

  _idToken() {
    return (idToken) => {
      this.request.set('Custom-ID-Token', idToken);
      return this.request;
    }
  }

  _recaptchaAction(recaptchaAction) {
    return (recaptchaAction) => {
      this.recaptchaAction = recaptchaAction;
      return this.request;
    }
  }

  _data() {
    return (obj) => {
      if (_.isEmpty(obj.files)) {
        this.sendData = _.merge(this.sendData, obj);
        this.request.type('form');
        this.request.send({data: JSON.stringify(this.sendData)});
      } else {
        //create form data object instead of usual request

        //get files and remove from data block
        let files = obj.files;
        delete obj.files;

        this.sendData = _.merge(this.sendData, obj);

        //add create formData and add data block
        let formData = new FormData();
        formData.append('data', JSON.stringify(this.sendData));

        _.forEach(files, (file, key) => {
          if (_.isArray(file)) {
            //add each file to formData array
            file.forEach((file) => {
              formData.append(`${key}[]`, file);
            });
          } else {
            //add file to formData
            formData.append(key, file);
          }
        });

        this.request.send(formData);
      }

      return this.request;
    };
  }

  _thenOverride() {
    return (resolve, reject) => {
      if (_.isFunction(resolve) === false || _.isFunction(reject) === false) {
        throw new Error('Resolve and Reject Must be Supplied');
      }

      if (this.recaptchaAction !== null) {
        //do recaptcha with google before api call
        global.grecaptcha
          .ready(() => {
            global.grecaptcha
              .execute(RECAPTCHA_SITE_KEY, {action: this.recaptchaAction})
              .then((token) => {
                // Verify the token on the server.
                this.request.set('Custom-Recaptcha-Token', token);
                this._callOriginalThen(resolve, reject);
              });
          });
      } else {
        //straight api call
        this._callOriginalThen(resolve, reject);
      }
    }
  }

  _callOriginalThen(resolve, reject) {
    this.originalThen.call(this.request, (res) => {
      this._updateEnvironmentFromRequest(res);
      resolve(res.body || res.text);
    }, (err) => {
      let response = err.response;
      let message = _.get(response, 'body.message', 'Unknown Error');
      let code = _.get(response, 'body.code', code);

      this._updateEnvironmentFromRequest(response);

      let additionalData = {
        request: {
          method: _.get(this.request, 'method'),
          url: _.get(this.request, 'url'),
          header: _.get(this.request, 'header'),
          query: _.get(this.request, '_query'),
          data: this.sendData
        },
        response: _.get(response, 'body', {})
      };

      let error = null;

      if (_.isEmpty(response)) {
        error = new InvalidResponse('Invalid Response From Server');
        error.additionalData(additionalData);
      } else if (response.badRequest || response.notFound) {
        error = new InvalidRequest(message, code);
        error.additionalData(additionalData);
      } else if (response.unauthorized || response.forbidden) {
        error = new AuthorisationError(message, code);
        error.additionalData(additionalData);
      } else {
        error = new ServerError(message, code);
        error.additionalData(additionalData);
      }

      reject(error);
    });
  }

  _updateEnvironmentFromRequest(response) {
    let environmentFromRemote = _.get(response, 'body.environment', null);

    if (store !== null && environmentFromRemote !== null) {
      store.dispatch('environment/mergeInNew', {environmentFromRemote});
    }
  }
}
